module.exports = __webpack_public_path__ + "static/assets/6e0ae2f947014b2c0394ec3cfef7d223.svg";